import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, ToastService, ModalService, PatientService, ValidateService } from '../../services';

@Component({
  selector: 'app-right-beacon-panel',
  templateUrl: './right-beacon-panel.component.html',
  styleUrls: ['./right-beacon-panel.component.scss']
})
export class RightBeaconPanelComponent implements OnInit {
  @Input() beacon;
  @Output() closePanelEvent = new EventEmitter<void>();
  @Output() beaconUpdated = new EventEmitter<void>();

  public beaconForm: FormGroup;
  public beaconZoneForm: FormGroup;
  public isSubmitting = false;
  /** Licznik nieudanych prób zapisu — każdy wzrost potrząsa niepoprawnymi polami. */
  public shakeToken = 0;

  public mask = {
    guide: true,
    showMask: true,
    mask: [/[a-z0-9]/, /[a-z0-9]/, ':', /[a-z0-9]/, /[a-z0-9]/, ':', /[a-z0-9]/, /[a-z0-9]/, ':', /[a-z0-9]/, /[a-z0-9]/, ':', /[a-z0-9]/, /[a-z0-9]/, ':', /[a-z0-9]/, /[a-z0-9]/]
  };

  constructor(
    private fb: FormBuilder,
    public location: Location,
    private translate: TranslateService,
    private modalService: ModalService,
    private toast: ToastService,
    private confirmation: ConfirmationService,
    private patientService: PatientService,
    private validateService: ValidateService,
  ) { }

  ngOnInit() {
    this.beaconForm = new FormGroup({
      id: new FormControl(this.beacon && this.beacon.id || null),
      name: new FormControl(this.beacon && this.beacon.name || '', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(40),
        Validators.pattern(/^((?!\s{2,}).)*$/),
        this.validateService.checkLengthName
      ]),
      mac: new FormControl(this.beacon && this.beacon.mac || '', [
        Validators.required,
        Validators.pattern('^([[a-zA-Z0-9-:]]*){17,17}$'),
        this.validateService.imeiValidation
      ])
    });

    this.beaconZoneForm = new FormGroup({
      address: new FormControl(this.beacon && this.beacon.address || ''),
      radius: new FormControl(200),
      interval: new FormControl(15),
      latitude: new FormControl(this.beacon && this.beacon.lat || 0),
      longitude: new FormControl(this.beacon && this.beacon.lon || 0)
    });
  }

  closePanel() {
    this.closePanelEvent.emit();
  }

  saveBeacon() {
    if (!this.beaconForm.valid) {
      this.validateService.validateAllFormFields(this.beaconForm);
      this.toast.showError(this.translate.instant('BACKEND.ALL_FIELDS_REQUIRED'));
      this.shakeToken++;
      return;
    }

    const name = this.beaconForm.get('name').value;
    this.isSubmitting = true;

    // Żądanie leci przy otwartym oknie: postęp widać na przycisku „Tak", a okno zamyka
    // się dopiero po odpowiedzi backendu.
    this.modalService.openAcceptAndRun(
      this.translate.instant('BACKEND.BEACON-CHECK'),
      () => {
        const lat = this.beaconZoneForm.get('latitude').value;
        const lon = this.beaconZoneForm.get('longitude').value;
        const address = this.beaconZoneForm.get('address').value;

        return this.patientService.editBeacon(
          this.beaconForm.get('id').value,
          this.beaconForm.get('mac').value,
          name,
          address ? address.replace(/\//g, "$47$") : 0,
          lat || 0,
          lon || 0
        );
      },
      'BUTTONS.SAVING',
      'EVENTS.SHARED.COMPONENTS.RIGHT-BEACON-PANEL.POPUP.BACKEND-BEACON-CHECK'
    ).subscribe(
      () => {
        this.closePanel();
        this.confirmation.showToast('BACKEND.BEACON-EDITED', { name });
        this.beaconUpdated.emit();
      },
      () => {
        // Bez tego nieudany zapis kończył się zamknięciem okna i ciszą.
        this.toast.showError(this.translate.instant('BACKEND.SOMETHING-WRONG'));
        this.isSubmitting = false;
      },
      () => this.isSubmitting = false
    );
  }

  deleteBeacon() {
    this.modalService.openAcceptAndRun(
      this.translate.instant('BACKEND.BEACON-ASK-DELETE', { name: this.beacon.name }),
      () => this.patientService.deleteBeacon(this.beacon.id),
      'BUTTONS.DELETING',
      'EVENTS.SHARED.COMPONENTS.RIGHT-BEACON-PANEL.POPUP.BACKEND-BEACON-ASK-DELETE'
    ).subscribe(
      () => {
        this.confirmation.showToast('BACKEND.BEACON-DELETED');
        this.beaconUpdated.emit();
        this.closePanel();
      },
      () => this.toast.showError(this.translate.instant('BACKEND.COULDNT-DELETE'))
    );
  }

  onButtonClick(type: string) {
    if (type === 'secondary') {
      this.closePanel();
    }
  }

  onKeyDown(event: KeyboardEvent, type: string) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onButtonClick(type);
    }
  }
}
